import type { ArtifactRegistry } from '../../../src/artifacts/registry.mjs';
import { createArtifactRegistry } from '../../../src/artifacts/registry.mjs';
import { appArtifactDescriptor } from '../../../src/apps/descriptor.mjs';

/**
 * The registry this host's Library uses: PR1's kinds, plus the App kind ONLY when the server's own kind list
 * (`GET artifacts/kinds`, its configured registry) says the App is installed, with the same schema version as
 * the descriptor this client was built with. Without that answer the Library is exactly PR1's: no App row,
 * no Apps filter, no claim that Apps exist. The descriptor is APP's, never copied.
 */
export function libraryRegistryFor(
  kinds: readonly { id: string; schemaVersion: number }[],
): ArtifactRegistry | undefined {
  const app = kinds.find((kind) => kind.id === 'app');
  if (!app || app.schemaVersion !== appArtifactDescriptor.schemaVersion) return undefined;
  return createArtifactRegistry([appArtifactDescriptor], { release: 'pr2' });
}
